<span class="tag text-5">{{ service() }}</span>
<h3 class="text-4 bold-1">{{ client() }}</h3>
<ng-content />
<a [href]="url()" target="_blank" rel="noopener noreferrer">{{ url() }}</a>
